<template>
  <w-icon-wrapper
    icon-name="work-filter-select"
    :height="20.07"
    :width="24"
    view-box="0 0 24 25"
  >
    <defs>
      <clipPath id="clip0_3_136">
        <rect
          width="24"
          height="25"
          fill="none"
        />
      </clipPath>
    </defs>
    <g>
      <path
        d="M10.93 24.33V13.38L10.58 12.87L3.81 3.06999L20.15 3.00999L14.08 11.73H16.53C18.68 8.63999 24 0.98999 24 0.98999L0 1.07999L8.92 14V25L10.93 24.33Z"
        fill="currentColor"
      />
      <path
        d="M24 13.94H13.53V15.44H24V13.94Z"
        fill="currentColor"
      />
      <path
        d="M24 17.26H13.53V18.76H24V17.26Z"
        fill="currentColor"
      />
      <path
        d="M20.12 20.59H13.53V22.09H20.12V20.59Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconFilterSelect' };
</script>